import React from 'react';
import { Button, Input, Label } from 'shared-portal-components-v2';

import { MIN_LEN } from '@/constants';

export interface UsernameFormViewProps {
  title: string;
  subtitle: string;

  emailLabel: string;
  setupCodeLabel: string;
  setupCodeHint: string;

  email: string;
  setupCode: string;

  emailError?: string;
  setupCodeError?: string;
  globalError?: string;

  isSubmitting: boolean;
  isResending: boolean;
  isContinueDisabled: boolean;
  isResendDisabled: boolean;

  onEmailChange: (value: string) => void;
  onSetupCodeChange: (value: string) => void;
  onSubmit: () => void;
  onResendOtp: () => void;
}

export function UsernameFormView(props: UsernameFormViewProps) {
  const {
    title,
    subtitle,
    emailLabel,
    setupCodeLabel,
    setupCodeHint,
    email,
    setupCode,
    emailError,
    setupCodeError,
    globalError,
    isSubmitting,
    isResending,
    isContinueDisabled,
    isResendDisabled,
    onEmailChange,
    onSetupCodeChange,
    onSubmit,
    onResendOtp,
  } = props;

  return (
    <div className="w-full max-w-md flex flex-col gap-8">
      <div className="text-center flex flex-col gap-2">
        <h1 className="text-3xl font-bold text-foreground">{title}</h1>
        <p className="text-muted-foreground text-lg">{subtitle}</p>
      </div>

      {globalError !== undefined && globalError.trim().length > MIN_LEN && (
        <div className="rounded-md border-l-4 border-destructive bg-destructive/5 p-3 text-sm text-destructive">
          {globalError}
        </div>
      )}

      <form
        className="flex flex-col gap-6"
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit();
        }}
      >
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <Label htmlFor="email" isRequired className="text-base">
              {emailLabel}
            </Label>
            <Input
              id="email"
              type="email"
              value={email}
              required
              variant="outline"
              error={emailError}
              inputClassName="h-12 text-base"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                onEmailChange(event.target.value);
              }}
              placeholder="Enter your email address"
            />
          </div>

          <div className="flex flex-col gap-2">
            <Label htmlFor="setupCode" isRequired className="text-base">
              {setupCodeLabel}
            </Label>
            <Input
              id="setupCode"
              type="text"
              value={setupCode}
              required
              maxLength={12}
              placeholder="Enter 12-character code"
              variant="outline"
              error={setupCodeError}
              inputClassName="h-12 text-base font-mono"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                onSetupCodeChange(event.target.value);
              }}
            />
            <div className="flex items-center justify-between gap-2">
              <p className="text-xs text-muted-foreground">{setupCodeHint}</p>
              <Button
                type="button"
                variant="link"
                className="h-auto p-0 text-xs"
                disabled={isResendDisabled}
                isLoading={isResending}
                onClick={onResendOtp}
              >
                Resend OTP
              </Button>
            </div>
          </div>
        </div>

        <Button
          type="submit"
          variant="primary"
          size="lg"
          isLoading={isSubmitting}
          disabled={isContinueDisabled}
        >
          Continue
        </Button>
      </form>
    </div>
  );
}

export default UsernameFormView;
